import React from 'react'
import PropTypes from 'prop-types'
import strings from 'utils/strings.js'
import {
  PhaseCircle,
  PhaseCircleBackground,
  PhaseCircleOutline,
  PhaseCirclePath,
  PhaseLabel,
} from './LifeCylceButtons.style'

const noop = () => {}

const DesignButton = ({
  isSelected,
  isSelectable,
  withLabel,
  onClick,
  transformX,
  transformY,
  labelTransform,
}) => (
  <>
    <PhaseCircle
      isSelected={isSelected}
      isSelectable={isSelectable}
      onClick={isSelectable ? onClick('regressAction') : noop}
      transform={`translate(${transformX} ${transformY})`}
      data-testid="lifecycle-design-button"
    >
      <PhaseCircleBackground
        cx="13"
        cy="12.966"
        r="12.5"
        strokeLinejoin="square"
      />
      <PhaseCircleOutline
        isSelected={isSelected}
        isSelectable={isSelectable}
        cx="13"
        cy="12.966"
        r="15"
        strokeWidth="1"
      />
      <PhaseCirclePath
        isSelected={isSelected}
        isSelectable={isSelectable}
        transform="translate(-7 -4)"
        strokeWidth="0.1"
        d="M25.78 20.495l-.884.883-.665-.665.907-.908-.805-.865-.985.985-.666-.665 1.675-1.675 2.96 3.18a.941.941 0 0 1-.023 1.307l-2.502 2.503a.941.941 0 0 1-1.331 0l-2.824-2.824.666-.665 2.823 2.823 2.502-2.502-.849-.912zm-9.424-9.538l-.912-.85-2.503 2.503 2.824 2.824-.666.665-2.823-2.823a.941.941 0 0 1 0-1.331l2.502-2.503a.941.941 0 0 1 1.307-.023l3.18 2.96-1.674 1.675-.666-.665.985-.986-.865-.805-.907.908-.666-.666.884-.883zm-1.847 8.65l-.491.492-.269 1.407c.916.476 1.546 1.005 1.89 1.589l1.238-.257.499-.5c-.413-1.628-1.804-2.56-2.867-2.73zm-1.361.031l.102-.102L23.603 9.183 23.788 9l.253.06c1.73.405 2.984 1.626 3.743 3.61.1.26.037.555-.16.752l-10.28 10.28-5.177 1.075.98-5.139z"
      />
    </PhaseCircle>
    {withLabel && (
      <PhaseLabel
        isSelected={isSelected}
        isSelectable={isSelectable}
        onClick={isSelectable ? onClick('regressAction') : noop}
        fontFamily="ArialMT, Arial"
        fontSize="12"
        transform={labelTransform}
      >
        <tspan x="0" y="45">
          {strings.design}
        </tspan>
      </PhaseLabel>
    )}
  </>
)

DesignButton.defaultProps = {
  withLabel: true,
  transformX: 7,
  transformY: 4,
  labelTransform: 'translate(0 4)',
}

DesignButton.propTypes = {
  isSelected: PropTypes.bool,
  isSelectable: PropTypes.bool,
  isDisabled: PropTypes.bool,
  withLabel: PropTypes.bool,
  onClick: PropTypes.func,
  transformX: PropTypes.number,
  transformY: PropTypes.number,
  labelTransform: PropTypes.string,
}

export default DesignButton
